import { BusinessRule } from '@app/business-rules/model';

export function predicateDisplayString(
  rule: BusinessRule,
  delimiter: string = ' '
): string {
  const arr = [];
  if (rule.predicateOperators.length === 0) {
    arr.push(
      rule.predicates[0].fieldName,
      rule.predicates[0].comparisonOperator,
      rule.predicates[0].comparisonValue
    );
  } else {
    for (let i = 0; i < rule.predicateOperators.length; i++) {
      const predicateOperator = rule.predicateOperators[i];
      if (i === 0) {
        arr.push(
          predicateOperator.firstPredicate.fieldName,
          predicateOperator.firstPredicate.comparisonOperator,
          predicateOperator.firstPredicate.comparisonValue,
          predicateOperator.operator,
          predicateOperator.secondPredicate.fieldName,
          predicateOperator.secondPredicate.comparisonOperator,
          predicateOperator.secondPredicate.comparisonValue
        );
      } else {
        arr.push(
          predicateOperator.operator,
          predicateOperator.secondPredicate.fieldName,
          predicateOperator.secondPredicate.comparisonOperator,
          predicateOperator.secondPredicate.comparisonValue
        );
      }
    }
  }
  return arr.join(delimiter);
}
